import api from '@loan/vb-node-loan/types/apiPlatform';
import { axios, i18n, reportLog, reportStatistics, requestPlatform } from '@tencent/vb-web-base';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { DEAL_TIME_OUT, FE_REQUEST_TIMEOUT } from '@common/core/help/constant';
import { NetworkError } from '@common/lib/error';
import { getServerTime, to } from '@tencent/vb-web-base-core';
import { v4 as uuid } from 'uuid';
dayjs.extend(isBetween);
// 提款预下单
export async function createLoanPre(req) {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(requestPlatform('/java/loan/core/withdrawMoneyPreDeal', 'POST', req));
    if (err) {
        throw new NetworkError({ code: err?.status, message: $t('预贷款异常'), tag: 'preLoanError' });
    }
    const { code, data } = respData;
    if (code !== 0) {
        throw new NetworkError({ code, message: respData.message, tag: 'preLoanProblem' });
    }
    return data;
}
// 提款正式下单
export async function createLoan(req) {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(requestPlatform('/java/loan/core/withdrawMoneyCreateDeal', 'POST', req));
    if (err) {
        throw new NetworkError({ code: err?.status, message: $t('贷款请求超时'), tag: 'loanTimeout' });
    }
    const { code, data, message } = respData;
    if (code !== 0) {
        if (DEAL_TIME_OUT.indexOf(code) !== -1) {
            throw new NetworkError({ code: FE_REQUEST_TIMEOUT, message: $t('贷款超时'), tag: 'loanTimeout' });
        }
        else {
            throw new NetworkError({ code, message, tag: 'loanProblem' });
        }
    }
    return data.loan_no;
}
/**
 * 拒绝额度
 * @param productNo
 */
export async function increaseLimit(params) {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(requestPlatform('/java/loan/limit/userApplyIncreaseLimit', 'POST', params));
    if (err !== null) {
        throw new NetworkError({
            code: err?.status,
            message: $t('系统繁忙，请稍后重试'),
            tag: 'userApplyIncreaseLimitError',
        });
    }
    const { code, message } = respData;
    // 重复上传
    if (code === 1038830106) {
        return 0;
    }
    if (code !== 0) {
        throw new NetworkError({ code, message, tag: 'userApplyIncreaseLimitProblem' });
    }
    return code;
}
/**
 * 提额状态改成18 但是工单没插入成功 如果是工单复用的话 可以直接掉用这个工单补充
 * @param
 */
export async function reuseProofRecord(params) {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(requestPlatform('/java/loan/approval/reuseProofRecord', 'POST', params));
    if (err !== null) {
        throw new NetworkError({
            code: err?.status,
            message: $t('系统繁忙，请稍后重试'),
            tag: 'reuseProofRecordError',
        });
    }
    const { code, message } = respData;
    // 重复上传
    if (code === 1038830106) {
        return 0;
    }
    if (code !== 0) {
        throw new NetworkError({ code, message, tag: 'reuseProofRecordtProblem' });
    }
    return code;
}
/**
 * 拒绝额度
 * @param productNo
 */
export async function rejectLimit(productNo, seq) {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(requestPlatform('/java/loan/limit/userRejectLimit', 'POST', {
        source: 'web-loan-limit',
        product_no: productNo,
        seq_no: seq || '',
    }));
    if (err) {
        throw { code: err?.status, message: $t('系统繁忙，请稍后重试'), tag: 'rejectLimitError' };
    }
    const { code } = respData;
    if (code !== 0) {
        throw { code, message: respData.message, tag: 'rejectLimitProblem' };
    }
    return code;
}
// 还款预下单
export async function repayPreDeal(req) {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(requestPlatform('/java/loan/core/repayMoneyPreDeal', 'POST', {
        source: 'web-loan-repay',
        ...req,
    }));
    if (err !== null) {
        throw { code: err?.status, message: $t('还款数据异常'), tag: 'preRepayError' };
    }
    const { code, data, message } = respData;
    if (code !== 0) {
        throw { code, message, tag: 'preRepayProblem' };
    }
    return data;
}
// 还款预下单
export async function writeOffRepayPreDeal(req) {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(requestPlatform('/java/loan/core/repayMoneyPreDeal', 'POST', {
        source: 'web-loan-repay',
        ...req,
    }));
    if (err !== null) {
        throw { code: err?.status, message: $t('还款数据异常'), tag: 'preRepayError' };
    }
    const { code, data, message } = respData;
    if (code !== 0) {
        throw { code, message, tag: 'preRepayProblem' };
    }
    return data;
}
// 还款下单
export async function repayDeal(req) {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(requestPlatform('/java/loan/core/repayMoneyCreateDeal', 'POST', {
        source: 'web-loan-repay',
        ...req,
    }));
    if (err !== null) {
        throw { code: err?.status, message: $t('还款数据异常'), tag: 'RepayError' };
    }
    const { code, data, message } = respData;
    if (code !== 0) {
        throw { code, message, tag: 'RepayProblem' };
    }
    return data;
}
// 还款下单
export async function repaywriteoffcreatedeal(req) {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(requestPlatform('/java/loan/core/repayMoneyCreateDeal', 'POST', {
        source: 'web-loan-repay',
        ...req,
    }));
    if (err !== null) {
        throw { code: err?.status, message: $t('还款数据异常'), tag: 'RepayError' };
    }
    const { code, data, message } = respData;
    if (code !== 0) {
        throw { code, message, tag: 'RepayProblem' };
    }
    return data;
}
/**
 * 确认额度
 */
export async function confirmLimit(req) {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(requestPlatform('/java/loan/limit/userConfirmLimit', 'POST', req));
    if (err) {
        throw { code: err?.status, message: $t('额度确认异常'), tag: 'confirmError' };
    }
    const { code } = respData;
    if (code !== 0) {
        throw { code, message: respData.message, tag: 'confirmProblem' };
    }
    return code;
}
// 提交地址证明
export async function submitProof(params) {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(requestPlatform('/java/loan/approval/uploadProofRecord', 'POST', params));
    console.log('paramsparamsparamsparams', params);
    if (err !== null) {
        throw new NetworkError({ code: err?.status, message: $t('系统繁忙，请稍后重试'), tag: 'submitError' });
    }
    const { code, message } = respData;
    if (code === 1038830106) {
        return 0;
    }
    if (code !== 0) {
        throw new NetworkError({ code, message, tag: 'submitProblem' });
    }
    return code;
}
// 开始缓存
export async function setApplyLimitCache(status, productNo, time) {
    const { getT } = i18n;
    const $t = getT();
    const applyLimitTime = time ?? getServerTime();
    const [respData, err] = await to(requestPlatform('/java/loan/limit/setApplyLimitCache', 'POST', {
        apply_limit_time: applyLimitTime,
        source: 'web-loan-limit',
        status,
        product_no: productNo,
    }));
    if (err !== null) {
        throw new NetworkError({ code: err?.status, message: $t('系统繁忙，请稍后重试'), tag: 'submitError' });
    }
    const { code, message } = respData;
    if (code !== 0) {
        throw new NetworkError({ code, message, tag: 'submitProblem' });
    }
    return code;
}
/**
 * 通用文件上传，返回cos文件地址
 * @param file
 * @param businessType
 */
export async function uploadFile(file, businessType) {
    const { getT } = i18n;
    const $t = getT();
    const formData = new FormData();
    reportStatistics({ evtName: 'uploadFile', extraMsg: file.name });
    const suffix = file.name.split('.').pop()?.toLowerCase() || 'jpg';
    const fileName = `${uuid()}.${suffix}`;
    formData.append('file', file, fileName);
    formData.append('businessType', businessType);
    formData.append('fileName', fileName);
    formData.append('source', 'uploadProofs');
    const headers = {
        'Content-Type': 'multipart/form-data',
    };
    // 这里app没有暴露api给h5 所以暂时只能先用axios
    const [respData, err] = await to(axios.post('/java/loan/upload', formData, { headers }));
    if (err) {
        console.error('err', err);
        throw new NetworkError({
            code: err.response?.status ?? -1,
            message: $t('系统繁忙，请稍后重试'),
            tag: 'commonUploadError',
        });
    }
    const { code, data, message } = respData.data;
    if (code !== 0) {
        throw new NetworkError({ code, message, tag: 'commonUploadProblem' });
    }
    return data.cos_id;
}
/**
 * 额度申请-预先下单
 * @param req
 */
export async function preCreateUserLimit(req) {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(requestPlatform('/java/loan/limit/userPreApplyLimit', 'POST', req));
    if (err) {
        throw new NetworkError({
            code: err?.status,
            message: $t('系统繁忙，请稍后重试'),
            tag: 'preUserLimitError',
        });
    }
    const { code, message, data } = respData;
    if (code !== 0) {
        if (code === 1039350019) {
            throw new NetworkError({ code, message: $t('非白名单用户，暂时不能申请额度'), tag: 'noWhiteList' });
        }
        else if (code === 1039350021) {
            throw new NetworkError({ code, message: $t('抱歉，您的申请未成功'), tag: 'reject' });
        }
        throw new NetworkError({ code, message, tag: 'preUserLimitProblem' });
    }
    return data;
}
export async function createUserLimit(req) {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(requestPlatform('/java/loan/limit/userApplyLimit', 'POST', req));
    if (err) {
        throw new NetworkError({
            code: err?.status,
            message: $t('系统繁忙，请稍后重试'),
            tag: 'createUserLimitError',
        });
    }
    const { code, message } = respData;
    if (code !== 0) {
        if (code === 1039350019) {
            throw new NetworkError({ code, message: $t('非白名单用户，暂时不能申请额度'), tag: 'noWhiteList' });
        }
        else if (code === 1039350021) {
            throw new NetworkError({ code, message: $t('抱歉，您的申请未成功，资格将逐步开放，敬请关注'), tag: 'reject' });
        }
        throw new NetworkError({ code, message, tag: 'createUserLimitProblem' });
    }
    return code;
}
export async function registerLimitSeqNo(req) {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(requestPlatform('/java/loan/namelist/registerLimitSeqNo', 'POST', req));
    if (err) {
        throw new NetworkError({
            code: err?.status,
            message: $t('系统繁忙，请稍后重试'),
            tag: 'registerLimitSeqNoError',
        });
    }
    const { code, message } = respData;
    if (code !== 0) {
        throw new NetworkError({ code, message, tag: 'registerLimitSeqNoProblem' });
    }
    return code;
}
/**
 * 证明后置上传接口
 * @param
 */
export async function postUploadProofRecord(params) {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(requestPlatform('/java/loan/approval/postUploadProofRecord', 'POST', params));
    if (err !== null) {
        throw new NetworkError({
            code: err?.status,
            message: $t('系统繁忙，请稍后重试'),
            tag: 'postUploadProofRecordError',
        });
    }
    const { code, message } = respData;
    // 重复上传
    if (code === 1038830106) {
        return 0;
    }
    if (code !== 0) {
        throw new NetworkError({ code, message, tag: 'postUploadProofRecordProblem' });
    }
    return code;
}
/**
 * 获取职业信息
 */
export async function getWorkInfo() {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(api.node.requestPlatformNodeGetWorkInfo());
    if (err) {
        throw new NetworkError({ code: err?.status, message: $t('获取职业信息异常'), tag: 'workInfoError' });
    }
    const { code, data, message } = respData;
    if (code !== 0) {
        throw new NetworkError({ code, message, tag: 'workInfoProblem' });
    }
    const workInfo = {
        job: { key: '', text: '' },
        industry: { key: '', text: '' },
        incomeRange: { key: '', text: '' },
        incomeFrom: {
            custom: '',
            options: [],
        },
        ioAmount: { key: '', text: '' },
        employments: [],
        position: { key: '', text: '' },
    };
    if (!data.job || !data.industry || !data.position) {
        reportLog({
            msg: 'h5WorkInfoError',
            stack: JSON.stringify(workInfo),
        });
    }
    if (data.job) {
        try {
            workInfo.job = JSON.parse(data.job);
        }
        catch (error) {
            reportLog({
                msg: 'h5JobError',
                stack: JSON.stringify(workInfo),
            });
            console.log(error);
        }
    }
    if (data.industry) {
        try {
            workInfo.industry = JSON.parse(data.industry);
        }
        catch (error) {
            reportLog({
                msg: 'h5IndustryError',
                stack: JSON.stringify(workInfo),
            });
            console.log(error);
        }
    }
    if (data.position) {
        try {
            workInfo.position = JSON.parse(data.position);
        }
        catch (error) {
            reportLog({
                msg: 'h5PositionError',
                stack: JSON.stringify(workInfo),
            });
            console.log(error);
        }
    }
    return workInfo;
}
/**
 * 获取用户状态
 */
export async function getUserStatus() {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(api.node.requestPlatformNodeGetUserStatus());
    if (err) {
        throw new NetworkError({ code: err?.status, message: $t('获取用户信息异常'), tag: 'getUserStatusError' });
    }
    if (respData.code !== 0) {
        throw new NetworkError({ code: respData.code, message: respData.message, tag: 'getUserStatusProblem' });
    }
    return respData.data;
}
export async function getProto(key) {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(api.node.requestPlatformNodeGetProtoConf({ key }));
    if (err) {
        throw new NetworkError({
            code: err?.status,
            message: $t('系统繁忙，请稍后重试'),
            tag: 'getTeslaConfigs',
        });
    }
    const { code, data, message } = respData;
    if (code !== 0) {
        throw new NetworkError({ code, message, tag: 'getTeslaConfigs' });
    }
    return data[0];
}
// 获取计算器活动配置
export async function getCalActInfo(key) {
    const [respData] = await to(api.node.requestPlatformNodeGetActConfig({ key }));
    const { code, message, serverTime } = respData;
    if (code !== 0) {
        throw new NetworkError({ code, message, tag: 'getCalActInfoError' });
    }
    const data = respData.data;
    const now = dayjs.unix(serverTime);
    const start = dayjs(data.beginDateTime);
    const end = dayjs(data.endDateTime);
    if (now.isBetween(start, end)) {
        return data;
    }
    return null;
}
/**
 * 查询优惠券列表
 * @returns
 */
export async function queryAllCouponList(couponCode, state) {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(api.node.requestPlatformNodeGetCouponList({ award_type: '8', coupon_code: couponCode, state, byAcct: '1' }));
    if (err) {
        throw new NetworkError({
            code: err?.status,
            message: $t('系统繁忙，请稍后重试'),
            tag: 'queryCouponListError',
        });
    }
    const { code, message } = respData;
    if (code !== 0) {
        throw new NetworkError({ code, message, tag: 'queryCouponListProblem' });
    }
    return respData.data.list;
}
/**
 * 查询优惠券奖品配置
 * @returns
 */
export async function queryAwardDetail(awardConfId) {
    const { getT } = i18n;
    const $t = getT();
    const [respData, err] = await to(api.node.requestPlatformNodeGetAwardDetail({ awardConfId }));
    if (err) {
        throw new NetworkError({
            code: err?.status,
            message: $t('系统繁忙，请稍后重试'),
            tag: 'queryawardDetailError',
        });
    }
    const { code, message } = respData;
    if (code !== 0) {
        throw new NetworkError({ code, message, tag: 'queryawardDetailProblem' });
    }
    return respData.data;
}
// 查询用户是否处于冻结状态
export async function queryFrozeInfo(params = {}) {
    const { getT } = i18n;
    const $t = getT();
    const [res, err] = await to(api.node.requestPlatformNodeGetFrozeInfo({ ...params }));
    if (err) {
        throw new NetworkError({
            code: err?.status,
            message: $t('系统繁忙，请稍后重试'),
            tag: 'queryFrozeInfoError',
        });
    }
    const { code, message, data } = res;
    if (code !== 0) {
        throw new NetworkError({ code, message, tag: 'queryFrozeInfoProblem' });
    }
    return data;
}
// 查余额
export async function getAccountBalance() {
    const { getT } = i18n;
    const $t = getT();
    const [res, err] = await to(api.node.requestPlatformNodeGetAcctBalance({
        ccy: 'HKD',
        acctNo: 'default',
        dt: 'D',
    }));
    if (err) {
        throw new NetworkError({
            code: err?.status,
            message: $t('系统繁忙，请稍后重试'),
            tag: 'balanceError',
        });
    }
    const { code, message, data } = res;
    if (code !== 0) {
        throw new NetworkError({ code, message, tag: 'balanceProblem' });
    }
    if (data.list.length === 0) {
        // 错误码系统中错误码： 获取账户列表为空
        throw new NetworkError({ code: 1040920002, message: $t('获取余额户口列表为空'), tag: 'balanceListEmpty' });
    }
    return data.list[0].balance;
}
// 检查分期贷款入口是否打开
export async function checkInstallWhiteList() {
    const [resp, err] = await to(api.node.requestPlatformNodeGetActCommonConfig({ id: 'loanInstallWhiteList' }));
    if (err) {
        return [];
    }
    if (resp.code !== 0 || !resp.data.ext_info) {
        return [];
    }
    try {
        const extInfo = JSON.parse(resp.data.ext_info);
        return extInfo.uid.value.split('@');
    }
    catch (error) {
        return [];
    }
}
